/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DropdownCategory = {
    Salutation: 'Salutation',
    Title: 'Title',
    Citizenship: 'Citizenship',
    MediaInquiry: 'MediaInquiry',
    ContactSource: 'ContactSource',
    Country: 'Country',
    City: 'City',
    EmploymentStatus: 'EmploymentStatus',
    AssignmentPriority: 'AssignmentPriority',
    CaseNoteLocation: 'CaseNoteLocation',
    CaseNoteResult: 'CaseNoteResult',
    Qualification: 'Qualification',
    MaritalStatus: 'MaritalStatus',
    LivingSituation: 'LivingSituation',
    ClientGoalAndResult: 'ClientGoalAndResult',
    ClientMeasures: 'ClientMeasures',
    ClientCauses: 'ClientCauses',
    AppointmentLocation: 'AppointmentLocation',
    ClaimLegalBasis: 'ClaimLegalBasis',
    Recommendation: 'Recommendation',
    RegisteredBy: 'RegisteredBy',
    Team: 'Team',
    WorkArea: 'WorkArea',
    SrvCounselingType: 'SrvCounselingType',
    SrvCourseEntryResult: 'SrvCourseEntryResult',
    IdentityDocumentType: 'IdentityDocumentType'
} as const;
export type DropdownCategory = typeof DropdownCategory[keyof typeof DropdownCategory];


export function instanceOfDropdownCategory(value: any): boolean {
    for (const key in DropdownCategory) {
        if (Object.prototype.hasOwnProperty.call(DropdownCategory, key)) {
            if (DropdownCategory[key as keyof typeof DropdownCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DropdownCategoryFromJSON(json: any): DropdownCategory {
    return DropdownCategoryFromJSONTyped(json, false);
}

export function DropdownCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropdownCategory {
    return json as DropdownCategory;
}

export function DropdownCategoryToJSON(value?: DropdownCategory | null): any {
    return value as any;
}

export function DropdownCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): DropdownCategory {
    return value as DropdownCategory;
}

